var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M0 396.481c0-218.738 181.885-396.481 405.722-396.481s405.722 177.743 405.722 396.481c0 98.483-36.731 188.584-97.701 258.004l310.257 303.919-67.123 65.596-313.987-306.107c-66.75 47.192-148.603 75.069-237.169 75.069-223.837 0-405.722-177.743-405.722-396.482zM763.712 396.481c0-193.503-159.977-349.836-357.99-349.836s-357.99 156.333-357.99 349.836c0 193.504 159.977 349.837 357.99 349.837s357.99-156.333 357.99-349.837z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.aeee9efa711dd2f9f1a86c5c481c486f.svg";
export { ForwardRef as ReactComponent };